
export default {
  auth: false,
  data() {
    return {
      loaded: false,
      searchProfiles: null,
      wasLoggedIn: false,
    };
  },
  async fetch() {
    const [SearchResults] = await Promise.all([
      this.$axios.get('/api/search.php', {
        params: {
          source: 'index',
          searchAllCountries: process?.env?.searchAllCountries ? 1 : 0,
          auto_load: 1,
          pp: 6,
          page: 4,
          trafficsource:
            this.$auth.$storage.getUniversal('network')?.network ||
            this.$route.query.network,
        },
      }),
    ]);
    this.searchProfiles = SearchResults.data.profiles;
    this.loaded = true;
  },
  mounted() {
    this.wasLoggedIn = this.$auth.loggedIn;
  },
};
